import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    deleteUser:false,
    deleteInvalidUser:false,
    deleteInvalidMsg:'',
    addUser:false,
    editUser:false,
    userLimit: null,
    setAllRoles:[],
    addRole:false,
    editRole:false,
    deleteRole:false,
    adminDetails:{},
    userDetails:{},
    getUserData:{},
};

 const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    deleteUserStatus: (state, action) => {
        state.deleteUser = action.payload;
      },
      deleteUserInvalidStatus: (state, action) => {
        state.deleteInvalidUser = action.payload.status;
        state.deleteInvalidMsg = action.payload.message || '';
      },
      addUserStatus: (state, action) => {
        state.addUser = action.payload;
      },
      editUserStatus: (state, action) => {
        state.editUser = action.payload;
      },
      setSupplierLimit: (state, action) => {
        state.userLimit = action.payload;
      },
      setAllRoles: (state, action) => {
        state.setAllRoles = action.payload;
      },
      addRoleStatus: (state, action) => {
        state.addRole = action.payload;
      },
      editRoleStatus: (state, action) => {
        state.editRole = action.payload;
      },
      deleteRoleStatus: (state, action) => {
        state.deleteRole = action.payload;
      },
      setAdminDetails: (state, action) => {
        state.adminDetails = action.payload;
      },
      setUserDetail: (state, action) => {
        state.userDetails = action.payload;
      },
      getUserDetail: (state, action) => {
        state.getUserData = action.payload;
      },
  },
});

export const {deleteUserStatus,getUserDetail,setUserDetail,deleteUserInvalidStatus,addUserStatus,editUserStatus,setSupplierLimit,setAllRoles,addRoleStatus,editRoleStatus,deleteRoleStatus,setAdminDetails} = userSlice.actions;

export default userSlice.reducer;
